<template>
<div class="card">
    <div v-if="!isLoaded" class="content">
        <placeholder-content isLoad="true" />
    </div>
    <div v-if="isLoaded" class="card-header  border-bottom my-0">
        <h5 class="card-title text-uppercase">{{$t('Top 10 Bestseller')}}</h5>
    </div>
    <div class="card-body">
        <v-chart v-if="isLoaded" class="chart" :option="option" autoresize/>
        <div class="no-data" v-if="hasData">
            <span>
                <h3>{{ $t("No Data to Display") }}</h3>
            </span>
        </div>
    </div>
</div>
</template>

<script>
import {
    use
} from "echarts/core";
import {
    CanvasRenderer
} from "echarts/renderers";
import {
    BarChart
} from "echarts/charts";
import {
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
} from "echarts/components";
import VChart, {
    THEME_KEY
} from "@/plugins/vue-echarts";
import moment from "moment";

import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
use([
    CanvasRenderer,
    TitleComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent,
    ToolboxComponent,
    BarChart,
]);
import {
    localSave,
    localRead
} from "@/store/lang";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone.js";

import numeral from "numeral";
export default {
    components: {
        VChart,
        PlaceholderContent
    },
    provide: {
        [THEME_KEY]: "default",
    },
    props: ["chartColumns", "yAxisText"],
    data() {
        let vm = this;
        return {
            lang: localRead("local"),
            hasData: false,
            option: {
                textStyle: {
                    fontFamily: 'Sarabun',
                },
                tooltip: {
                    trigger: "axis",
                    textStyle: {
                        fontSize: 14,
                    },
                    axisPointer: {
                        type: "shadow",
                    },
                    formatter : function (params) {
                    var tempData = [];
                    let txt = '';
                    txt += '<div class="mb-1 px-3" style="width:300px">';
                    txt += moment(vm.chartColumns.start).locale(vm.lang).format('D MMM') + ' - ' + moment(vm.chartColumns.end).locale(vm.lang).format('D MMM');
                        for (let param of params) {
                            // console.log('param' ,param)
                            txt += '<div class="mb-1">';
                                txt += '<div class="font-weight-semibold" style="word-wrap: break-word;white-space: normal;overflow: hidden;display: -webkit-box;text-overflow: ellipsis;-webkit-box-orient: vertical;-webkit-line-clamp: 1;">' + param.marker + '<span class="mr-1"></span>' + param.name  + '</div>';
                                txt += '<div class="ml-3">';
                                    txt += '<div class="d-flex justify-content-between">';
                                        txt += '<span>' + vm.$t("_Shipping.Number of Orders") + '</span>';
                                        txt += '<span>' + numeral(param.data.sum_order_quantity).format("0,0") + '</span>';
                                    txt += '</div>';

                                    txt += '<div class="d-flex justify-content-between">';
                                        txt += '<span>' + vm.$t("Number of Products") + '</span>';
                                        txt += '<span>' + numeral(param.data.sum_product_order_quantity).format("0,0") + '</span>';
                                    txt += '</div>';

                                    txt += '<div class="d-flex justify-content-between">';
                                        txt += '<span>' + vm.$t("Sales") + '</span>';
                                        txt += '<span>' + numeral(param.data.sum_product_total).format("0,0.00") + '</span>';
                                    txt += '</div>';
                                txt += '</div>';
                            txt += '</div>';
                        }
                        return  txt;
                    },
                },
                grid: {
                    top: 40,
                    bottom: 0,
                    left: 0,
                    right: 5,
                    containLabel: true,
                },
                xAxis: [{
                    type: "category",
                    data: [],
                    axisLabel: {
                        width: 100,
                        overflow: 'truncate',
                        interval: 0,
                    },
                    axisTick: {
                        alignWithLabel: true,
                    },
                }, ],
                yAxis: {
                    name: this.yAxisText,
                    type: "value",
                    nameTextStyle: {
                        align: "left",
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed"
                        }
                    },
                    axisLabel: {},
                },
                legend: {
                    left: "right",
                    itemHeight: 10,
                    itemWidth: 10,
                },
                series: false,
            },
            isLoaded: false,
        };
    },
    async mounted() {
        this.option.xAxis[0].data = this.chartColumns.series
        this.option.yAxis.type = "value"
        this.option.series = [{
            data: this.chartColumns.data,
            type: 'bar',
            barMaxWidth: 75,
            barWidth: "80%",
            barGap: "20%",
            itemStyle: {
                color: "#03A9F4"
            }
        }]
        this.option.hasData = false;
        this.isLoaded = true;
    },

    methods: {

    },
    watch: {
        chartColumns: function (newValue, oldValue) {
            if(this.chartColumns.series[0] == "") {
                this.hasData = true;
            }else {
                this.hasData = false;
            }
            this.option.xAxis[0].data = this.chartColumns.series;
            this.option.series = [{
                data: this.chartColumns.data,
                type: 'bar',
                barMaxWidth: 75,
                barWidth: "80%",
                barGap: "20%",
                itemStyle: {
                    color: "#03A9F4"
                }
            }]
        }
    }
};
</script>

<style scoped>
.chart {
    height: 370px;
}
.no-data {
    position: absolute;
    opacity: 0.25;
    height: 100%;
    width: 100%;
    top: 0;
}
.no-data span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 1.5em;
    white-space: nowrap;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/product/BestsellerChart.vue